// Button component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Salert from 'react-s-alert'
import classnames from 'classnames'
import { isMobile } from '../../../lib/browser'

const getConfig = ({ options }) => ({
  position: isMobile ? 'top' : 'top-right',
  effect: 'scale',
  beep: false,
  timeout: options.timeout || 3000,
  html: options.html || false,
  offset: isMobile ? 0 : 100
})

class Alert extends Component {
  static get propTypes () {
    return {
      message: PropTypes.string,
      type: PropTypes.string,
      onClose: PropTypes.func,
      className: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      message: '',
      type: '',
      onClose: null,
      className: ''
    }
  }

  render () {
    const classes = classnames('alert', {}, this.props.className)
    return (
      <div className={classes}>
        <Salert onClose={this.props.onClose} />
      </div>
    )
  }

  /* Public Functions */
  onShow (msg, type, options = null) {
    if (type === 'error') {
      this._showErrorMessage(msg, options)
    } else if (type === 'success') {
      this._showSuccessMessage(msg, options)
    } else if (type === 'info') {
      this._showInfoMessage(msg, options)
    } else if (type === 'warning') {
      this._showWarningMessage(msg, options)
    }
  }

  onClose (_e) {
    Salert.close()
  }

  /* Private Functions */
  _showErrorMessage (msg, options) {
    options = options || {}

    Salert.error(msg, getConfig({ options }))

    return false
  }

  _showSuccessMessage (msg, options) {
    options = options || {}

    Salert.success(msg, getConfig({ options }))

    return false
  }

  _showInfoMessage (msg, options) {
    options = options || {}

    Salert.info(msg, getConfig({ options }))

    return false
  }

  _showWarningMessage (msg, options) {
    options = options || {}

    Salert.warning(msg, getConfig({ options }))

    return false
  }
}

export default Alert
